"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToAtMostTwoDecimals = roundToAtMostTwoDecimals;
exports.dollarsToCents = dollarsToCents;
exports.hoursToMinutes = hoursToMinutes;
function roundToAtMostTwoDecimals(n) {
    return Number(`${Math.round((n + 'e2'))}e-2`);
}
/** Converts a dollar amount to whole cents, preserving null/undefined as null. */
function dollarsToCents(dollars) {
    return dollars == null ? null : Math.round(dollars * 100);
}
/** Converts hours to whole minutes, preserving null/undefined as null. */
function hoursToMinutes(hours) {
    return hours == null ? null : Math.round(hours * 60);
}
//# sourceMappingURL=number-utils.js.map